import { GripStrengthReference } from "../../references";
import female from "./female.json";
import male from "./male.json";

export const GripStrength = {
  Female: female as GripStrengthReference[],
  Male: male as GripStrengthReference[],
} as const;
